/**
 * @description 保留小数，如：keepDecimals(3.14159, 2) === 3.14
 * @param number 输入数字
 * @param decimal 需要保留的小数位数
 * @returns 输出四舍五入的有效数字
 */
const keepDecimal = (number: number, decimal = 2): number => {
  const _number = Number(number);
  const _decimal = Number(decimal);
  if (isNaN(_number) || isNaN(_decimal)) {
    console.error(`keepDecimal needs number as arguments, but got "${number}" "${decimal}"`);
    return number;
  } else {
    const result = Number(_number.toFixed(_decimal));
    if (!isNaN(result)) {
      return result;
    } else {
      console.error(
        `keepDecimal occurred a error, related information: { number: ${_number}, decimal: ${_decimal}, result: ${result} }`,
      );
      return number;
    }
  }
};

export default keepDecimal;
